import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { ReactNode } from 'react';
import styled from 'styled-components/native';
import useBool from '../utils/state/useBool';
import Dialog from './Dialog';
import DialogHeader from './Dialog/DialogHeader';
import { InfoButton } from './InfoButton';

interface Props {
  title?: string;
  body?: ReactNode;
}

export const InfoDialogButton = (props: Props) => {
  const [dialog_visible, showDialog, hideDialog] = useBool();

  return (
    <>
      <InfoButton onPress={showDialog} />
      <StyledDialog visible={dialog_visible} onClose={hideDialog}>
        <DialogHeader
          center={
            <Text variant="h3" weight="bold">
              {props.title}
            </Text>
          }
          right={
            <Button icon="times" variant="secondary" onPress={hideDialog} />
          }
        />
        {props.body}
      </StyledDialog>
    </>
  );
};

const StyledDialog = styled(Dialog)`
  padding: 20px 30px 30px;
`;
